import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { Users, Heart, Target, Newspaper, ExternalLink, ArrowRight, ShieldCheck } from 'lucide-react';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
export function BDE() {
  return <div className="flex flex-col w-full" data-id="element-661">
      <PageHeader title="Le BDE Zillenium" subtitle="Un bureau des étudiants engagé, formateur et fédérateur. Découvrez une vie étudiante dynamique et solidaire." data-id="element-662" />

      <div className="flex flex-col w-full" data-id="element-663">
        {/* Intro & Projets */}
        <section className="py-24 bg-muted relative overflow-hidden" data-id="element-664">
          <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-665" />
          <div className="container max-w-6xl mx-auto relative z-10" data-id="element-666">
            <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-667">
              <SectionHeading title="Association BDE Zillenium" centered className="mb-6" data-id="element-668" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-8" data-id="element-669">
                Le Bureau des Étudiants est un espace clé de la vie étudiante.
                Il permet aux apprenants de se rencontrer, de s'engager et de
                construire ensemble des projets concrets qui développent
                l'esprit d'équipe, la prise d'initiative et le sens des
                responsabilités.
              </p>
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 inline-block text-left" data-id="element-670">
                <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-4" data-id="element-671">
                  Des projets incroyables se préparent :
                </h3>
                <div className="flex flex-wrap gap-3 justify-center sm:justify-start" data-id="element-672">
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-673">
                    Maraude solidaire
                  </Badge>
                  <Badge className="bg-primary text-white hover:bg-primary-dark border-none px-4 py-2 text-sm" data-id="element-674">
                    Tournoi inter-écoles
                  </Badge>
                  <Badge className="bg-primary-dark text-white hover:bg-primary border-none px-4 py-2 text-sm" data-id="element-675">
                    Sensibilisation au don du sang
                  </Badge>
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-676">
                    Bal de promo
                  </Badge>
                </div>
              </div>
            </div>

            {/* Association loi 1901 */}
            <div className="max-w-3xl mx-auto mb-20" data-id="element-677">
              <Card className="border-none shadow-md bg-white overflow-hidden" data-id="element-678">
                <div className="h-1.5 w-full bg-primary" data-id="element-679" />
                <CardContent className="p-6 sm:p-8 flex flex-col sm:flex-row items-start gap-5" data-id="element-680">
                  <div className="w-12 h-12 shrink-0 bg-lavande rounded-xl flex items-center justify-center" data-id="element-681">
                    <ShieldCheck className="w-6 h-6 text-primary" data-id="element-682" />
                  </div>
                  <div data-id="element-683">
                    <h3 className="font-bold text-lg text-primary-dark mb-2" data-id="element-684">
                      Association déclarée sous la loi 1901
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-sm" data-id="element-685">
                      Le Bureau des Étudiants de Zillenium est une association
                      régie par la loi du 1<sup data-id="element-686">er</sup> juillet 1901, déclarée
                      à la sous-préfecture de Sens.
                    </p>
                    <div className="flex flex-wrap gap-x-8 gap-y-2 mt-4 text-sm" data-id="element-687">
                      <span data-id="element-688">
                        <span className="text-muted-foreground" data-id="element-689">N° RNA : </span>
                        <span className="font-semibold text-primary-dark" data-id="element-690">
                          W893007506
                        </span>
                      </span>
                      <span data-id="element-691">
                        <span className="text-muted-foreground" data-id="element-692">
                          Siège social :{' '}
                        </span>
                        <span className="font-semibold text-primary-dark" data-id="element-693">
                          25 rue Gabriel Cortel, 89300 Joigny
                        </span>
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-694">
              <Card className="border-none shadow-xl bg-primary text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-695">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-696">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-697">
                    <Users className="w-8 h-8 text-lavande animate-soft-bounce" data-id="element-698" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-699">
                    SE RETROUVER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-700">
                    Des actions solidaires et citoyennes portées par les
                    étudiants
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-brand-orange text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-701">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-702">
                  <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-703">
                    <Heart className="w-8 h-8 text-white animate-soft-pulse" data-id="element-704" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-705">
                    S'AMUSER
                  </h3>
                  <p className="text-white/90 leading-relaxed" data-id="element-706">
                    Une vie étudiante dynamique, conviviale et engagée
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-primary-dark text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-707">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-708">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-709">
                    <Target className="w-8 h-8 text-lavande animate-soft-float" data-id="element-710" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-711">
                    CRÉER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-712">
                    Des projets associatifs concrets, de la conception à la
                    réalisation
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* BDE Press Article */}
            <div className="mb-16" data-id="element-713">
              <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-white" data-id="element-714">
                <div className="h-2 w-full bg-brand-orange" data-id="element-715" />
                <CardContent className="p-8 sm:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-716">
                  <div className="w-20 h-20 shrink-0 bg-brand-orange/10 rounded-2xl flex items-center justify-center" data-id="element-717">
                    <Newspaper className="w-10 h-10 text-brand-orange" data-id="element-718" />
                  </div>
                  <div className="flex-1 text-center md:text-left" data-id="element-719">
                    <Badge className="bg-slate-100 text-slate-600 hover:bg-slate-200 border-none mb-4" data-id="element-720">
                      Dans la presse • L'Yonne Républicaine
                    </Badge>
                    <h3 className="font-bold text-xl md:text-2xl text-primary-dark mb-4 leading-tight" data-id="element-721">
                      À Joigny, les étudiants lancent des journées de partage
                      pour redynamiser La Madeleine et lutter contre la
                      précarité étudiante
                    </h3>
                    <p className="text-muted-foreground mb-6" data-id="element-722">
                      Une belle mise en lumière de l'engagement de nos étudiants
                      et du BDE Zillenium dans la presse locale.
                    </p>
                    <Button asChild variant="outline" className="group border-slate-200 hover:border-brand-orange hover:text-brand-orange" data-id="element-723">
                      <a href="https://www.lyonne.fr/joigny-89300/actualites/pour-redynamiser-la-madeleine-et-lutter-contre-la-precarite-des-etudiants-vont-initier-des-journees-de-partage-a-joigny_14964196/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2" data-id="element-724">
                        Lire l'article complet
                        <ExternalLink className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-725" />
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* BDE Video Gallery */}
            <div className="mb-16" data-id="element-726">
              <SectionHeading title="La vie du BDE en images" centered className="mb-10" data-id="element-727" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-728">
                {['https://www.instagram.com/reel/DWMvJXWgcw9/embed', 'https://www.instagram.com/p/DWPZmA5Ad9k/embed', 'https://www.instagram.com/reel/DZ0K5pFNFOZ/embed', 'https://www.instagram.com/reel/DZsokh-OUor/embed', 'https://www.instagram.com/p/DZrtdYhIr7B/embed', 'https://www.instagram.com/p/DZPobROjY_C/embed', 'https://www.instagram.com/reel/DY7lQJ5uSwb/embed', 'https://www.instagram.com/reel/DY5HdDCO9pL/embed'].map((url, i) => <div key={i} className="bg-white p-3 rounded-[2rem] shadow-lg border border-slate-100 hover:-translate-y-1 hover:shadow-xl transition-all duration-300" data-id="element-729">
                    <div className="relative rounded-[1.5rem] overflow-hidden bg-slate-100 aspect-[9/16]" data-id="element-730">
                      <iframe src={url} title={`Vidéo BDE ${i + 1}`} className="absolute inset-0 w-full h-full" frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-731"></iframe>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-732">
              <Button size="lg" className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl w-full sm:w-auto" asChild data-id="element-733">
                <a href="https://www.instagram.com/bdezillenium/" target="_blank" rel="noopener noreferrer" data-id="element-734">
                  Suivre le BDE sur Instagram
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* CTA Candidater */}
        <section className="py-24 bg-primary-dark text-white relative overflow-hidden" data-id="element-735">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-40 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-736" />
          <div className="container text-center max-w-4xl mx-auto relative z-10" data-id="element-737">
            <h2 className="font-heading text-4xl md:text-5xl font-extrabold mb-8 tracking-tight" data-id="element-738">
              Envie de rejoindre l'aventure ?
            </h2>
            <p className="text-lavande text-xl mb-12 leading-relaxed font-medium" data-id="element-739">
              Intégrez une école dynamique où l'alternance rime avec engagement,
              solidarité et réussite.
            </p>
            <Button size="lg" className="bg-white hover:bg-lavande text-primary-dark text-lg px-10 py-7 shadow-xl group" asChild data-id="element-740">
              <Link to="/candidater" className="flex items-center" data-id="element-741">
                Candidater maintenant
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-742" />
              </Link>
            </Button>
          </div>
        </section>
      </div>
    </div>;
}